module.exports = __webpack_public_path__ + "img/randabstand-EC2-ansicht.2a8a66c1.svg";